<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <!-- 弹窗, 新增 / 修改 -->
    <rewardUpdate v-show="addOrUpdateVisible" @refreshDataList="refreshDataList" ref="rewardUpdate"></rewardUpdate>
  </div>
</template>

<script>
    import tablePage from '@/views/mis/customerRelation/table.vue'
    import FORM from '../components/page/form.vue'
    import rewardUpdate from '../rebate/rewardUpdate.vue'
    import DataUtil from '@/views/mis/util/data'
    import download from '@/utils/download'
    //接口地址url的统一管理
    import URL from '@/views/mis/util/url'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    import Qs from 'qs'
    import axios from 'axios'

    let activeStatus = {"-1": "活动状态", "DRAFT": "待执行", "PENDING": "执行中", "DISABLE": "禁用", "END": "已到期"};
    let proposalStatus = {"0": "待审批", "1": "已审批"}
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            rewardUpdate
        },
        methods: {
            checkbox(row) {
                this.deleteIds = row.map(key => key.id).join(",");
            },
            /*表格按钮点击事件*/
            bthClick(clickName, row) {
                if (clickName == "update") {
                    console.log(clickName, row)
                    this.addOrUpdateHandle(row,false);
                } else if (clickName == "details") {
                    this.addOrUpdateHandle(row,true);
                }else if (clickName == "apply") {
                    //校验
                    this.dataChanage(URL.rebateActivity.applyProposal, {ids: row.id}, res => {
                        if (res.code == 0) {
                            this.$message.success(window.$t('mis.accountReward.applySuccess'));
                            this.$refs.childTable.defaultGetData(this.queryData);
                        } else {
                            this.$message.error(window.$t('mis.accountReward.applyFail'));
                        }
                    });
                }else if (clickName == "disable") {
                    //校验
                    this.dataChanage(URL.rebateActivity.disableProposal, {ids: row.id}, res => {
                        if (res.code == 0) {
                            this.$message.success(window.$t('mis.accountReward.applySuccess'));
                            this.$refs.childTable.defaultGetData(this.queryData);
                        } else {
                            this.$message.error(window.$t('mis.accountReward.applyFail'));
                        }
                    });
                }
            },
            // 新增 / 修改
            addOrUpdateHandle(row,type) {
                this.addOrUpdateVisible = true;
                this.$nextTick(() => {
                    this.$refs.rewardUpdate.detail = type;
                    this.$refs.rewardUpdate.dataForm.activeType = 1;
                    this.$refs.rewardUpdate.init(row)
                })
            },
            /*查询表单按钮点击事件*/
            formclick(clickName, data) {
                if ("查询" == clickName || window.$t('mis.bt.query') == clickName) {
                    this.queryData = data;
                    this.$refs.childTable.defaultGetData(data);
                } else if (window.$t('mis.bt.add') == clickName) {
                    this.addOrUpdateHandle(false,false);
                } else if (window.$t('mis.bt.down') == clickName) {
                    download.exportExcel(URL.rebateActivity.downloadActivity, data, window.$t('mis.accountReward.downloadActivity0'));
                }
            },
            refreshDataList() {
                this.$refs.childTable.defaultGetData(this.queryData);
            },
            dataChanage(url, option, suc, fail) {
                this.axios.post(url, Qs.stringify(option || {})).then(res => {

                    if (suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if (fail && (typeof fail == 'function')) fail(res);
                })
            },
        },
        data() {
            return {
                addOrUpdateVisible: false,   // 新增／更新，弹窗visible状态
                queryData: {},
                dataForm: {},
                /*from查询表单*/
                formData: {
                    hasLable: true,
                    cols: [
                        {title: window.$t('mis.common.startTime'), field: 'beginDate', type: 5, format: 'yyyy-MM-dd HH:mm:ss'},
                        {title: window.$t('mis.common.endTime'), field: 'endDate', type: 5, format: 'yyyy-MM-dd HH:mm:ss'},
                        {title: window.$t('mis.accountReward.activeId'), field: 'activeId'},
                        {title: window.$t('mis.accountReward.activeStatus'), field: 'activeStatus', type: 2, optionList: activeStatus},
                        {title: window.$t('mis.accountReward.activeName'), field: 'activeName'},
                        {title: window.$t('mis.accountReward.activeType'), field: 'activeType', data: 1, hidden: true},
                        {click: window.$t('mis.bt.query')},
                        {click: window.$t('mis.bt.add')},
                        {click: window.$t('mis.bt.down')}
                    ]
                },
                /*table生成*/
                pageData: {
                    queryUrl: URL.rebateActivity.list, //请求路径和参数
                    selection: true,
                    sequence: true,
                    cols: [
                        {
                            colspan:true,
                            title: window.$t('mis.bt.operation'),
                            click: "update",
                            width:'170',
                            btns:[
                                    {
                                        field: window.$t('mis.bt.edit'),
                                        condition: 'DRAFT',
                                        size: "mini",
                                        type: "primary",
                                        click: "update",
                                        icon: "el-icon-update"
                                    },
                                    {
                                        field: window.$t('mis.bt.disable'),
                                        condition: 'PENDING',
                                        size: "mini",
                                        type: "danger",
                                        click: "disable",
                                        icon: "el-icon-update"
                                    },
                                    {
                                        field: window.$t('mis.rewardDealList.apply'),
                                        condition: 'DRAFT',
                                        size: "mini",
                                        type: "warning",
                                        click: "apply",
                                        icon: "el-icon-update"
                                    },
                                    {
                                        field: activeStatus['END'],
                                        condition: 'END',
                                        size: "mini",
                                        type: "info",
                                        click: "disable",
                                        icon: "el-icon-update"
                                    },
                                    {
                                        field: window.$t('mis.bt.enable'),
                                        condition: 'DISABLE',
                                        size: "mini",
                                        type: "success",
                                        click: "apply",
                                        icon: "el-icon-update"
                                    }
                                ]
                        },
                        {title: window.$t('mis.accountReward.proposalNo'), field: 'proposalNo',h5Click: "details"},
                        {title: window.$t('mis.accountReward.activeId'), field: 'activeId'},
                        {title: window.$t('mis.accountReward.activeName'), field: 'activeName'},
                        {
                            title: window.$t('mis.accountReward.activeStatus'), field: 'activeStatus', render: (data, full) => {
                                return activeStatus[data] || "";
                            }
                        },
                        {
                            title: window.$t('mis.accountReward.proposalStatus'), field: 'proposalStatus', render: (data, full) => {
                                return proposalStatus[data] || "";
                            }
                        },
                        {title: window.$t('mis.accountReward.beginDate'), field: 'beginDate'},
                        {title: window.$t('mis.accountReward.endDate'), field: 'endDate'},
                        {title: window.$t('mis.accountReward.expDay'), field: 'expDay'},
                        {title: window.$t('mis.accountReward.proposalUser'), field: 'proposalUser'},
                        {title: window.$t('mis.accountReward.proposalDate'), field: 'proposalDate'},
                        {title: window.$t('mis.accountReward.approvalUser'), field: 'approvalUser'},
                        {title: window.$t('mis.accountReward.approvalDate'), field: 'approvalDate'},
                    ]
                }
            }
        }
    }
</script>
